import { useTranslations } from "next-intl";
import { useMemo, useState, useEffect } from "react";
import classNames from "classnames";
import { useButtonEventTracking } from "@hooks/use-button-event-tracking";
import {
  useOpenReviewShortOffcanvas,
  useReviewShortOffcanvasOpened,
} from "@hooks/use-review-short";
import Image from "@components/core/Image";
import Link from "@components/core/Link";
import IconSvg from "@components/core/IconSvg";
import closetStates from "@utils/constants/closetStates";

function ClosetShortReview({ origin = "drawer", closet, reloadCloset = () => {}, className }) {
  const t = useTranslations("common");

  const trackEvent = useButtonEventTracking();
  const openReviewShortOffcanvas = useOpenReviewShortOffcanvas();
  const isReviewShortOffcanvasOpened = useReviewShortOffcanvasOpened();

  const displayShortReviewButton = useMemo(() => {
    return !!closet.closet_items.filter(
      (closetItem) =>
        !closetItem.review?.short_review_done && closetItem.product.family !== "accessory",
    ).length;
  }, [closet.closet_items]);

  const [openedOffCanvas, setOpenedOffCanvas] = useState(false);

  function openShortReviewOffCanvas() {
    trackEvent(`closet_${closet.state}_short_review`);

    openReviewShortOffcanvas(closet);
    setOpenedOffCanvas(true);
  }

  useEffect(() => {
    if (!isReviewShortOffcanvasOpened && openedOffCanvas) {
      reloadCloset();
      setOpenedOffCanvas(false);
    }
  }, [isReviewShortOffcanvasOpened, openedOffCanvas, reloadCloset]);

  return (
    <div className={classNames("d-flex flex-column gap-3", className)}>
      {displayShortReviewButton && (
        <button
          className="btn-transparent open-short-review-offcanvas-btn"
          onClick={openShortReviewOffCanvas}
        >
          <div className="image-container">
            <Image
              src="partyNature"
              className="w-100"
              alt={t("drawer.review_short.btn.alt")}
            />
          </div>
          <div className="d-flex flex-column">
            <div className="d-flex align-items-center gap-3">
              <p className="font-weight-bold mb-0">{t("drawer.review_short.btn.title")}</p>
              <div className="arrow-container">
                <IconSvg name="arrow-right-lg" />
              </div>
            </div>
            <div>
              <p className="mb-0 text-gray">{t("drawer.review_short.btn.subtitle")}</p>
            </div>
          </div>
        </button>
      )}

      {origin === "history" && closet.state === closetStates.received && (
        <div className="d-flex gap-1">
          <span className="text-gray">
            {t("drawer.review_short.defective.text")}{" "}
            <Link href={`/help/contact-us/defective?closetId=${closet.id}`}>
              {t("drawer.review_short.defective.link")}
            </Link>
          </span>
        </div>
      )}
    </div>
  );
}

export default ClosetShortReview;
